// The BattleBooks crest outline — the same traced path as the phone's CrestAvatar (mobile/src/components/CrestAvatar.js)
// and the books' Crest.tsx. 500×622; never change the ratio.
export const CREST_W = 500;
export const CREST_H = 622;
export const CREST_D =
  'M251 0 L0 79 L0 344 C1.3 348.7 5.2 362.8 8 372 C10.8 381.2 13.8 390 17 399 ' +
  'C20.2 408 23.2 417 27 426 C30.8 435 35 444 40 453 C45 462 50.5 471 57 480 ' +
  'C63.5 489 70.7 498 79 507 C87.3 516 96.3 525 107 534 C117.7 543 129.7 552 143 561 ' +
  'C156.3 570 170.8 579 187 588 C203.2 597 229.3 609.5 240 615 C250.7 620.5 249.2 620 251 621 ' +
  'C250.8 620 249.3 620.5 260 615 C270.7 609.5 296.8 597 313 588 C329.2 579 343.7 570 357 561 ' +
  'C370.3 552 382.3 543 393 534 C403.7 525 412.7 516 421 507 C429.3 498 436.5 489 443 480 ' +
  'C449.5 471 455 462 460 453 C465 444 469.2 435 473 426 C476.8 417 479.8 408 483 399 ' +
  'C486.2 390 489.2 381.2 492 372 C494.8 362.8 498.7 348.7 500 344 L500 79 Z';
